// extracted by mini-css-extract-plugin
export default {"base":"eOMXmIKwk4BDe1PZSLKBaA=="};